import React, { useState } from "react";
import axios from "axios";
import "../styles/Search.css";
import searchIcon from "../images/searchIcon.svg";
import { useAuth } from "../auth/auth";
const apiUrl = process.env.REACT_APP_API_URL;

const Search = ({ onSearch, onClear, searchPath = "/search", year }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [message, setMessage] = useState(null);
  useAuth();

  const showMessage = (text) => {
    setMessage(text);

    // Hide the message after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      setMessage(null);
    }, 2000);
  };

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      if (typeof onClear === "function") {
        onClear();
      }
      return;
    }

    try {
      const response = await axios.get(
        `${apiUrl}${searchPath}?query=${searchQuery}${
          year ? `&year=${year}` : ""
        }`
      );
      //console.log('search response', response.data[0].email)
      if (response.data.length > 0) {
        //const userEmail = response.data[0].email;
        onSearch(response.data);
      } else {
        //console.log('No user found.');
        //alert("No Results Found");
        showMessage("No Results Found");
      }
    } catch (error) {
      //console.error("Search failed:", error);
    }
  };

  const handleClear = () => {
    setSearchQuery("");
    if (typeof onClear === "function") {
      onClear();
    }
  };

  return (
    <div className="search-container">
      <div className="search-input-container">
        <input
          type="text"
          placeholder="Search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSearch();
            }
          }}
          className="search-input"
        />
        {searchQuery.trim() && (
          <button
            type="button"
            className="search-clear-icon"
            onClick={handleClear}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
        <img
          src={searchIcon}
          alt="Search Icon"
          className="search-icon"
          onClick={handleSearch}
        />
      </div>
      {message && (
        <div className="custom-modal">
          <div className="modal-content">{message}</div>
        </div>
      )}
    </div>
  );
};

export default Search;
